export default class SupportAbstractServices {
  static getContactUsReferenceData() {
    logger.error('Support:: getContactUsReferenceData() not implemented');
  }

  static getContactUsConfirmationReferenceData() {
    logger.error('Support: getContactUsConfirmationReferenceData() not implemented');
  }
}
